<dx-drop-down-button
    [elementAttr]="{ class: 'menu-button' }"
    [text]="'enum_language_' + selected?.languageCode | transloco"
    [items]="options"
    keyExpr="locale"
    [displayExpr]="formatOption"
    [dropDownOptions]="{
        wrapperAttr: { class: 'language-dropdown-wrapper' },
        width: '248px',
        height: 'auto',
    }"
    (onSelectionChanged)="selectLang($event)"
    stylingMode="text"
    template="template"
    itemTemplate="languageMenuItem"
>
    <div *dxTemplate="let data of 'template'" class="tab">
        {{ 'enum_language_' + selected?.languageCode | transloco }}
        <i class="cn-icon-ico-chevron-down"></i>
    </div>
    <a *dxTemplate="let item of 'languageMenuItem'" class="dropdown-switcher-item" routerLinkActive="active">
        <span>{{ item?.emoji }} {{ item?.country | transloco }} ({{ 'enum_language_' + item?.languageCode | transloco }})</span>
    </a>
</dx-drop-down-button>
